define([
	"dojo/_base/declare",
	"csi/config",
	"csi/core/Key",
	"csi/state/rootStore",
	"csi/xml",
	"csi/xml/Query",
	"Apparel/ProductType",
	"Apparel/StructureItemTable",

	// include to ensure renderer class loaded for matrix
	"Apparel/StyleSizeActiveRenderer"
], function(declare, config, Key, {routerStore}, xml, Query, ProductType, StructureItemTable) {

	const THEME_TO_SEASON = "ThemeToSeason";
	const ALL_SEASONS = "ThemeToSeason:AllSeasons";

	return declare(StructureItemTable, {
		PARAM_COLORWAY_URL: "colorwayUrl",
		TYPE_SIZE: "ProductSize",
		TYPE_STYLE: "Style",

		/** @property {Spec} sizeMatrixSpec - spec for size matrix if being displayed */
		sizeMatrixSpec: null,

		/**
		 * @override
		 * Determine if size matrix is in view
		 */
		onBuildColumns(ctx, dfds) {
			const sizeMatrixKey = new Key({
				extendedPath: this.specBuilder.defaultSourcePath,
				id: "ProductSizes"
			});
			this.sizeMatrixSpec = this.columnData.getByKey(sizeMatrixKey.typedString, true, true);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * If on hierarchy node, then apply additional filter; this supports use of view in switchboard on hierarchy nodes
		 */
		onCreateMainQueryLevel(ql) {
			const {locationUrl, locationType} = routerStore;
			const idRelation = this.TypeRelations[locationType];

			if (idRelation) {
				console.assert(!ql.serverQuery);
				ql.serverQuery = new Query().RefAttr(idRelation, xml.OP_EQUALS, locationUrl);
			}

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Refresh entire row if size range changed which affects Sizes matrix
		 */
		_onRefreshAttribute(ctx, h, ren, refNode, bPendingChange) {
			this.inherited(arguments);

			if (h.m_id == "ActualSizeRange") {
				this.redrawNode(refNode);
			}
		},

		/**
		 * Determine if Colorway Active checkbox can be edited
		 */
		onAccessActionActiveColorway(ctx, action) {
			const style = (ctx.getNodeType() === this.TYPE_STYLE) ? ctx.getNode() : ctx.getParent();
			return style.Active && ProductType.hasColor(style);
		},

		/**
		 * Determine if new Colorway can be created for the Style
		 */
		onAccessActionNewColorway(ctx, action) {
			const style = ctx.getParent();
			return style.Active && ProductType.hasColor(style);
		},

		/**
		 * Determine hide the action or not
		 */
		onAccessActionNewStyleUnderTheme(ctx, action) {
			const theme = ctx.getContextNode();
			const themeMaster = ctx.cache.getNode(theme.__Parent__);
			const subtypeSetting = config.getNodeSetting(themeMaster, THEME_TO_SEASON);

			return themeMaster.Active && (subtypeSetting === ALL_SEASONS || !!theme.ThemeSeasons?.length);
		},
	});
});